export var RESPONSIVE_FIELD_GRID_SX = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
    gap: '16px',
    width: '100% !important',
    margin: '0 !important',
    '& > .MuiGrid-item': {
        width: 'auto !important',
        maxWidth: 'none !important',
        flexBasis: 'auto !important',
        padding: '0 !important',
        minWidth: 0,
    },
    '& > .MuiGrid-item[class*="MuiGrid-grid-xs-12"]:not([class*="MuiGrid-grid-sm-"]):not([class*="MuiGrid-grid-md-"]):not([class*="MuiGrid-grid-lg-"])': {
        gridColumn: '1 / -1',
    },
};
